import { render, staticRenderFns } from "./OzDrawerDraggable.vue?vue&type=template&id=a09f9f52&scoped=true&"
import script from "./OzDrawerDraggable.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerDraggable.vue?vue&type=script&lang=ts&"
import style0 from "./OzDrawerDraggable.vue?vue&type=style&index=0&id=a09f9f52&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f9f52",
  null
  
)

export default component.exports